<template>
  <router-view />
</template>
<script>
export default {
	name: 'App',
}
</script>
<style>
#app{height: 100vh;}
input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}
input[type="number"] {
	-moz-appearance: textfield;
}
.el-date-editor .el-range-separator {
	width: 30px;
}
.loading_mask {
	z-index: 3000 !important;
}
.el-table th>.cell{
	word-break:break-word;
}
.filter_panel{width: 100%; display: flex; }
.filter_panel .filter_form{flex: 1; }
.filter_panel .filter_button{min-height:47px;text-align: right; }
</style>



// WEBPACK FOOTER //
// src/App.vue